export default __webpack_public_path__ + "/dist/images/investment-img.39cdf136e584ec797090ee9060ef14e9.png";